import { GoalPeriod } from '@akin-home/amplify';
import { z } from 'zod';

export const CreateGoalCommand = z.object({
  type: z.literal('create_goal'),

  data: z.object({
    title: z.string(),
    emoji: z.string().optional(),
    period: z.nativeEnum(GoalPeriod).optional(),
    completions_per_period: z.coerce.number().optional(),

    success_message: z.string().optional(),
    error_message: z.string().optional(),
  }),
});

export type CreateGoalCommand = z.infer<typeof CreateGoalCommand>;
